// extracted by mini-css-extract-plugin
export default {"wrapper":"Progress_wrapper__1WUwy","outer":"Progress_outer__yzRcD","inner":"Progress_inner__hCg2p","svg":"Progress_svg__8f43R","circle":"Progress_circle__OFrvH"};